// Percentile (p between 0 and 1) with linear interpolation between ranks,
// same result as Excel PERCENTILE.INC, so the values can be checked in a spreadsheet
export default function percentile (values, p) {
  if (!values.length) return null
  const sorted = [...values].sort((a, b) => a - b)
  const index = (sorted.length - 1) * p
  const lower = Math.floor(index)
  const upper = Math.ceil(index)
  return sorted[lower] + (sorted[upper] - sorted[lower]) * (index - lower)
}
